import { useState } from 'react'
import SearchBar from './components/SearchBar'
import MovieList from './components/MovieList.jsx'
import './App.css'

const API_KEY = '468b8b60'

export default function App() {
  const [movies, setMovies] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [searched, setSearched] = useState(false)

  async function searchMovies(query) {
    if (!query.trim()) return
    setLoading(true)
    setError('')
    setSearched(true)
    try {
      const res = await fetch(`https://www.omdbapi.com/?s=${query}&apikey=${API_KEY}`)
      const data = await res.json()
      if (data.Response === 'True') {
        setMovies(data.Search)
      } else {
        setMovies([])
        setError('No movies found. Try another search.')
      }
    } catch (err) {
      setError('Something went wrong. Please try again.')
    }
    setLoading(false)
  }

  return (
    <div className="app">
      <div className="hero">
        <h1 className="title">🎬 MovieSearch</h1>
        <p className="subtitle">Search any movie instantly</p>
        <SearchBar onSearch={searchMovies} />
      </div>
      <div className="container">
        {loading && <p className="status">Searching...</p>}
        {error && <p className="status error">{error}</p>}
        {!loading && !error && searched && movies.length === 0 && (
          <p className="status">No results found.</p>
        )}
        {!loading && movies.length > 0 && <MovieList movies={movies} />}
      </div>
    </div>
  )
}